module.exports = __webpack_public_path__ + "static/record-d0289dc0a46fc5b15b3363ffa78cf6c7.png";